import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, InputNumber, Switch, Tag, Space, message, Popconfirm } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, LockOutlined, UnlockOutlined } from '@ant-design/icons';
import api from '../utils/api';
import { useMenuPermission } from '../hooks/useMenuPermission';

function StatusManage() {
  const { canEdit } = useMenuPermission();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingStatus, setEditingStatus] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await api.get('/statuses');
      if (res.code === 200) setData(res.data);
    } catch (err) {}
    setLoading(false);
  };

  const handleAdd = () => {
    setEditingStatus(null);
    form.resetFields();
    form.setFieldsValue({ is_locked: 0, sort_order: 0 });
    setModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingStatus(record);
    form.setFieldsValue(record);
    setModalVisible(true);
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      // Switch返回boolean，转为0/1
      values.is_locked = values.is_locked ? 1 : 0;
      let res;
      if (editingStatus) {
        res = await api.put(`/statuses/${editingStatus.id}`, values);
      } else {
        res = await api.post('/statuses', values);
      }
      if (res.code === 200) {
        message.success(editingStatus ? '更新成功' : '创建成功');
        setModalVisible(false);
        loadData();
      }
    } catch (err) {}
  };

  const handleDelete = async (id) => {
    try {
      const res = await api.delete(`/statuses/${id}`);
      if (res.code === 200) {
        message.success('删除成功');
        loadData();
      }
    } catch (err) {}
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: '状态名称', dataIndex: 'name', width: 200 },
    {
      title: '是否锁定', dataIndex: 'is_locked', width: 100,
      render: v => (
        <Tag color={v === 1 ? 'red' : 'green'} icon={v === 1 ? <LockOutlined /> : <UnlockOutlined />}>
          {v === 1 ? '锁定' : '正常'}
        </Tag>
      )
    },
    { title: '排序', dataIndex: 'sort_order', width: 80 },
    {
      title: '创建时间', dataIndex: 'created_at', width: 160,
      render: v => v ? new Date(v).toLocaleString() : '-'
    },
    {
      title: '操作', key: 'action', width: 150,
      render: (_, record) => (
        <Space>
          {canEdit && <Button type="link" size="small" icon={<EditOutlined />} onClick={() => handleEdit(record)}>编辑</Button>}
          {canEdit && (
            <Popconfirm title="确定删除？删除前请确保该状态下无订单。" onConfirm={() => handleDelete(record.id)}>
              <Button type="link" size="small" danger icon={<DeleteOutlined />}>删除</Button>
            </Popconfirm>
          )}
        </Space>
      )
    }
  ];

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
        <h3>状态管理</h3>
        {canEdit && <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>新增状态</Button>}
      </div>

      <Table
        rowKey="id"
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={false}
      />

      <Modal
        title={editingStatus ? '编辑状态' : '新增状态'}
        open={modalVisible}
        onOk={handleSave}
        onCancel={() => setModalVisible(false)}
        width={400}
      >
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="状态名称" rules={[{ required: true, message: '请输入状态名称' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="is_locked" label="是否锁定" valuePropName="checked">
            <Switch checkedChildren="锁定" unCheckedChildren="正常" />
          </Form.Item>
          <Form.Item name="sort_order" label="排序（越小越靠前）">
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default StatusManage;
